"use client";

import { motion } from "framer-motion";
import { fadeUp, scaleIn, Section } from "./utils";

export function Comparison() {
  const rows = [
    { feature: "Time to first action", old: "4-24 hours", tethra: "Under 5 minutes" },
    { feature: "After-hours coverage", old: "None", tethra: "24/7, 365 days" },
    { feature: "Follow-up consistency", old: "Depends on who remembers", tethra: "Automatic, every time" },
    { feature: "Pipeline management", old: "Manual spreadsheet entry", tethra: "Agents update in real time" },
    { feature: "Task handoffs", old: "Slack / email / hope", tethra: "Agents hand off automatically" },
    { feature: "Business context", old: "Starts from scratch every time", tethra: "Agents remember every interaction" },
    { feature: "Monthly cost", old: "3-4 tools + extra hires", tethra: "One platform, one price" },
  ];

  return (
    <Section className="px-6 py-28 max-w-4xl mx-auto">
      <motion.div variants={fadeUp} className="text-center mb-14">
        <p className="text-sm font-medium text-coral-400 mb-3 uppercase tracking-wider">
          Before vs. after
        </p>
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-content">
          What changes when your AI crew takes over.
        </h2>
      </motion.div>

      <motion.div
        variants={scaleIn}
        className="bg-surface-secondary/50 border border-surface-border rounded-2xl overflow-hidden"
      >
        <div className="grid grid-cols-3 gap-4 px-6 py-4 border-b border-surface-border bg-surface-tertiary/50">
          <div className="text-sm font-medium text-content-secondary" />
          <div className="text-sm font-medium text-content-muted text-center">
            Manual / Today
          </div>
          <div className="text-sm font-medium text-coral-400 text-center">
            With Tethra
          </div>
        </div>

        {rows.map((row, i) => (
          <div
            key={i}
            className="grid grid-cols-3 gap-4 px-6 py-4 border-b border-surface-border/30 last:border-0 hover:bg-surface-secondary/30 transition-colors"
          >
            <div className="text-sm text-content/80">{row.feature}</div>
            <div className="text-sm text-content-muted text-center">{row.old}</div>
            <div className="text-sm text-ok text-center font-medium">
              {row.tethra}
            </div>
          </div>
        ))}
      </motion.div>
    </Section>
  );
}
